<template>
  <div>
    <label class="input-reader">
      ファイルを選択
      <input type="file" @change="readFileContent" :accept="fileType" />
    </label>
    <span class="input-file-explanation">{{ resultExplanation }}</span>
  </div>
</template>

<script>
export default {
  props: {
    fileType: {
      // CSV: .csv
      // PDF: .pdf
      // Excel 97-2003: application/vnd.ms-excel
      // Excel 2007+: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      // Text: text/plain
      // Image: image/*
      // HTML: text/html
      // Video: video/*
      // Audio: audio/*
      type: String,
      default: null,
    },
  },
  data() {
    return {
      resultExplanation: null,
    };
  },
  methods: {
    readFileContent(event) {
      try {
        const file = event.target.files[0];
        this.resultExplanation = event.target.files[0].name;
        this.$logger.debug('Picked File:', this.resultExplanation);

        const reader = new FileReader();
        reader.onload = (event) => {
          this.$logger.debug('Read Content:', event.target.result);
          this.$emit('contentLoaded', event.target.result);
        };
        reader.readAsText(file);
      } catch (error) {
        this.resultExplanation = 'ファイルを開けません';
        this.$emit('contentLoadFailed', this.resultExplanation);
      }
    },
  },
};
</script>

<style scoped>
.input-reader {
  position: relative;
  overflow: hidden;
  display: inline-block;
  background-color: #eeeeee;
  border-radius: 0;
  border-color: #afafaf;
  border: 1px solid gray;
  font-size: 9px;
  height: 17.7px;
  padding: 1px 13px 5px 13px;
  margin: 6px 12px 0px 0px;
  cursor: pointer;
}
.input-reader input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
}
.input-file-explanation {
  font-size: 12px;
}
</style>
